import { motion } from "framer-motion";
import { Phone, Mail, MessageCircle, MapPin, Clock } from "lucide-react";
import { useSettings, waLink } from "../hooks/useSettings";
import { useI18n } from "../context/I18nContext";

export default function Contact() {
  const s = useSettings();
  const { t } = useI18n();
  return (
    <div className="min-h-screen pt-[72px]">
      <div className="relative py-16 sm:py-24 lg:py-28 overflow-hidden">
        <img src="/media/riviera-background.jpeg" alt="" className="absolute inset-0 w-full h-full object-cover blur-[3px] scale-110" />
        <div className="absolute inset-0 bg-[#05060A]/72" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#05060A]/55 to-[#05060A]" />
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12">
          <motion.p initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} className="text-[11px] tracking-luxe uppercase text-[#E5C378] mb-4">{t("contact.badge")}</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F0E1] drop-shadow-lg">{t("contact.title")}</motion.h1>
          <p className="text-[#D8DDD7] mt-4 max-w-2xl drop-shadow">{t("contact.subtitle")}</p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 pb-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        {[
          { icon: Phone, label: t("contact.phone"), value: s.phone, href: `tel:${s.phone}`, testid: "contact-phone" },
          { icon: Mail, label: t("contact.email"), value: s.email, href: `mailto:${s.email}`, testid: "contact-email" },
          { icon: MessageCircle, label: t("contact.whatsapp"), value: t("contact.whatsappValue"), href: waLink(s.whatsapp, "Bonjour GROZNY LOCATION"), testid: "contact-whatsapp", green: true },
          { icon: MapPin, label: t("contact.zone"), value: t("contact.zoneValue"), testid: "contact-zone" },
        ].map((c) => {
          const Wrapper = c.href ? "a" : "div";
          return (
            <Wrapper key={c.label} {...(c.href ? { href: c.href, target: c.href.startsWith("http") ? "_blank" : undefined, rel: "noreferrer" } : {})}
              data-testid={c.testid}
              className="group gz-card rounded-[24px] p-8 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(212,175,55,0.14)] transition-all duration-400 flex items-start gap-5">
              <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 ${c.green ? "bg-[#25D366]/15 text-[#25D366]" : "bg-[#D4AF37]/12 text-[#D4AF37]"}`}>
                <c.icon className="w-5 h-5" />
              </div>
              <div>
                <div className="text-[10px] tracking-luxe uppercase text-[#7E8C84] mb-1.5">{c.label}</div>
                <div className="text-[#F5F0E1] text-lg font-display">{c.value}</div>
              </div>
            </Wrapper>
          );
        })}
      </div>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 pb-20">
        <div className="rounded-[28px] bg-[#0B0B0F] border border-[#D4AF37]/15 p-10 flex flex-col sm:flex-row items-center justify-between gap-6 shadow-[0_20px_60px_rgba(0,0,0,0.5)]">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-[#D4AF37]/10 backdrop-blur-md flex items-center justify-center">
              <Clock className="w-7 h-7 text-[#E5C378]" />
            </div>
            <div>
              <div className="font-display text-2xl text-white">{t("contact.concierge")}</div>
              <p className="text-white/60 text-sm">{t("contact.conciergeSub")}</p>
            </div>
          </div>
          <a href={waLink(s.whatsapp, "Bonjour GROZNY LOCATION")} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#20bd5a] text-white px-7 py-3.5 text-sm tracking-widest uppercase transition-colors">
            <MessageCircle className="w-4 h-4" /> {t("contact.writeWhatsapp")}
          </a>
        </div>
      </div>
    </div>
  );
}
